import React from 'react';
import { StyleSheet, View, TouchableWithoutFeedback } from 'react-native';

import Text from '../global/Text';
import fontMaker from '../../utils/font';
import { ActiveLanguageName } from '../../constants/Languages';
import { LandingContainerProps } from './LandingContainer';
import { useDispatch } from 'react-redux';
import { landingActions } from '../../store/reducers/landing';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';

type LandingHeaderProps = Pick<LandingContainerProps, 'language' | 'onLanguageChange'>;

const LandingHeader = (props: LandingHeaderProps) => {
  const dispatch = useDispatch();

  const handleShowLanguageSelectorModal = () => {
    dispatch(landingActions.setModalLanguageVisible(true));
    return;
  };

  return (
    <View style={styles.landingHeader}>
      <View style={styles.languageContainer}>
        <TouchableWithoutFeedback onPress={() => handleShowLanguageSelectorModal()}>
          <View style={[styles.select]}>
            <Text allowFontScaling={false} style={[styles.languageText]}>
              {ActiveLanguageName(props.language)}
            </Text>
            <Icon name="chevron-down" size={18} color="#535353" />
          </View>
        </TouchableWithoutFeedback>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  landingHeader: {
    position: 'absolute',
    top: 16,
    right: 20,
    zIndex: 10
  },
  languageContainer: {
    flexDirection: 'row',
    alignSelf: 'flex-start',
    height: 40
  },
  select: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 8,
    borderColor: '#D0D5DD',
    borderWidth: 1,
    paddingHorizontal: 14,
    paddingVertical: 8,
    backgroundColor: '#fff'
  },
  languageText: {
    ...fontMaker({ weight: 'Medium' }),
    fontSize: 14,
    textAlign: 'center',
    color: '#344054',
    marginRight: 6
  }
});

export default LandingHeader;
